<template>
  <v-container class="pa-0">
    <MobileTopPart />
    <v-row>
      <v-col>
        <v-container fluid>
          <v-row>
            <v-col
              cols="12"
              class="px-5 pt-5 py-3"
            >
              <SearchForm />
            </v-col>
            <v-col class="white">
              <MyLoader
                v-if="$store.state.progressSearching"
                :style="{
                  marginTop: '50px',
                }"
              />
              <List v-else />
            </v-col>
          </v-row>
          <v-row class="white py-7">
            <v-col> </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <!-- v-row>
      <PageFooter />
    </v-row -->
  </v-container>
</template>

<script>
import MyLoader from '@/components/App/_MyLoader'
import List from '@/components/List/List'
import MobileTopPart from '@/components/Views/Layout/MobileTopPart'
import SearchForm from '@/components/Forms/SearchForm'
import sharedComputed from '@/methods/sharedComputed'
export default {
  name: 'ListPageMobile',

  components: {
    SearchForm,
    MobileTopPart,
    List,
    MyLoader,
  },

  computed: {
    ...sharedComputed,
  },
}
</script>
